import { CloseIcon, RemoveToolIcon, WarnIcon } from '@/icons';
import { type ToolRow } from '@/components/ToolsPage/toolData';
import styles from '@/components/ToolsPage/RemoveToolModal.module.css';

interface RemoveToolModalProps {
  readonly tool: ToolRow;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
}

export function RemoveToolModal({ tool, onConfirm, onClose }: RemoveToolModalProps): JSX.Element {
  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-label="Remove Tool"
      onClick={onClose}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <span className={styles.title}>Remove Tool</span>
          <button className={styles.close} onClick={onClose} type="button" aria-label="Close">
            <CloseIcon width={20} height={20} />
          </button>
        </div>

        <div className={styles.badge}>
          <span className={styles.badgeGlow} />
          <RemoveToolIcon className={styles.badgeIcon} />
        </div>

        <div className={styles.headline}>
          <span className={styles.toolNo}>Remove Tool {tool.no}?</span>
          {tool.type !== '' && (
            <span className={styles.sub}>
              {tool.type} • {tool.diameter}
            </span>
          )}
        </div>

        <div className={styles.warning}>
          <WarnIcon width={20} height={20} />
          This will remove the tool from the list.
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.btnGhost} onClick={onClose}>
            Cancel
          </button>
          <button type="button" className={styles.btnDanger} onClick={onConfirm}>
            Remove Tool
          </button>
        </div>
      </div>
    </div>
  );
}
